import styled from "styled-components";
import { trodlyFontRegular, trodlyBlack } from "../styles/Constants";

export const Paragraph = styled.p`
  font-size: ${ props => props.size};
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin: ${props => props.margin};
  text-align: ${props => props.align};
`;



Paragraph.defaultProps = {
    size: "1rem",
    color: trodlyBlack,
    weight: trodlyFontRegular,
    margin: "0 0 0.5rem",
    align: 'left'
}
